import { useTheme } from '@shopify/restyle';
import { images } from 'app/design/images';
import { Column, Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { useScopedTranslation } from 'app/hooks/i18n';
import { View } from 'react-native';
import { PCImage } from 'app/design/primitives/image';
import { Check } from 'app/design/images/check';
import { BalloonCard } from 'app/design/images/balloon-card';
import { env } from 'app/lib/env';
import type { Theme } from 'app/shopify';

export function ReferralProgramExample({ numInvited }: { numInvited: number }) {
  const { t } = useScopedTranslation();
  const theme = useTheme<Theme>();
  return (
    <Row
      style={{
        width: '90%',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        marginBottom: -theme.spacing['spacing.general.x1'],
        marginTop: -theme.spacing['spacing.general.x4'],
        marginLeft: theme.spacing['spacing.general.x2'],
      }}
    >
      <Column style={{ alignItems: 'center', justifyContent: 'center', top: 5 }}>
        <View style={{ width: 64, height: 64 }}>
          <PCImage source={images.martinBeauchamp} style={{ width: 64, height: 64 }} />
          <Check width={64 / 2.5} height={64 / 2.5} style={{ position: 'absolute', bottom: 0, right: 0 }} />
        </View>
        <Text fontSize={11} fontWeight={500} variant="bodyBase">
          {t('referralProgram.referrals.1referral', { ns: 'invite' })}
        </Text>
      </Column>
      <Text
        fontSize={32}
        fontWeight="500"
        style={{ marginHorizontal: -theme.spacing['spacing.general.x4'], color: theme.colors['text.placeholder'] }}
      >
        =
      </Text>
      <Column style={{ alignItems: 'center', justifyContent: 'center' }}>
        <View>
          <BalloonCard height={83} width={123} />
          <PCImage
            source={env.IS_PARTAKE ? images.logoThreeLinesPartake : images.logoThreeLines}
            height={50}
            width={50}
            style={{ position: 'absolute', top: 15, left: 123 / 2 - 25 }}
          />
        </View>
        <Text
          fontSize={11}
          fontWeight={500}
          textAlign="center"
          variant="bodyBase"
          style={{ marginTop: -theme.spacing['spacing.general.x1'] }}
        >
          {t('referralProgram.referrals.1monthFree', { ns: 'invite', numInvites: numInvited })}
        </Text>
      </Column>
    </Row>
  );
}
